import { Controller } from '@hotwired/stimulus';
import i18n from '../lib/i18n';

export default class extends Controller {
  update({ detail: { count } }) {
    const disabled = count === 0;

    this.element.disabled = disabled;
    this.element.parentElement.title = disabled
      ? i18n.t('components.bundles.editor_toolbar_component.save_disabled')
      : '';
  }
}
